import { configureStore } from '@reduxjs/toolkit';
import authSlice from './Auth';
import layoutSlice from './Layout';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    layout: layoutSlice
  },
})